/***
 * @Authors:
 *      Rahul
 ***/

/*** Imports ***/

import "./styles2.css";

/* Library imports */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import axios from "axios";
import { makeStyles } from '@material-ui/core/styles';
import { GoogleLogin } from 'react-google-login';

/* Component imports */
import * as UtilityLg from "../../UtilityLg";
import * as Services from "../../Services/services";
import ConstantsLg from "../../ConstantsLg";
import ContentLg from "../../ContentLg";
import MobileModal from '../core/MobileModal/MobileModal';

import ResetPasswordScreen from '../ProfessionalLoginEmailMobile/components/ResetPasswordScreen/ResetPasswordScreen';
import SuccessScreen from '../ProfessionalLoginEmailMobile/components/SuccessScreen/SuccessScreen';
import LoginScreen from '../ProfessionalLoginEmailMobile/components/LoginScreen/LoginScreen';
import LandingScreenProfessionalEmail from './components/LandingScreen/LandingScreenProfessionalEmail';
import TopWrapper from '../core/LoginWrapper/TopWrapper';
import LoginHeader2 from '../core/LoginHeader/LoginHeader2';

let _cancelGoogleLogin = null ;

class ProfessionalLoginEmailMobile extends Component{

    constructor(props){
        super(props);
        this.state = {
            title: ContentLg.SIGNUP_LOGIN,
            showBack: false,
            showClose: true,
            showFooter: true,
            isNextDisabled: false,
            showMessageEmailDirty: false,
            showErrorMessagePasswordMismatch: false,
            showMessagePublicEmailDomain: false,
            btnBackLabel: ContentLg.BTN.BACK,
            btnNextLabel: ContentLg.BTN.NEXT,
            successHeader: null,
            successMsg: null,
            pageIdentifier: ConstantsLg.LOGIN_PAGE_IDENTIFIER.PROF_LANDING_PAGE,
            emailValidationMsg: ContentLg.MSG.INVALID_EMAIL,
            pswdValidationMsg: null,
            email: '',
            password: ''
        };

        this.isEmailValid = false;
        this.isEmailDirty = false;
        this.isPswdValid = false;
        this.isPswdDirty = false;
        this.professionalEmail = '';
        this.professionalPassword = '';

        UtilityLg.bindThisToAll(this, "onLandingTxtBxEmailChange", "onLandingNextBtnClick",
            "signUpProfessional", "onBackClick", "onNextClick", "onTxtBxPswdChange", "onLoginSubmitClick",
            "onForgotPassword", "onResetPswdSubmitClick", "onHeaderLeftBtnClick", "onHeaderRightBtnClick",
            "onTxtBxEmailEnter", "onTxtBxPswdEnter", "onEmailEditClick"
        );
    }

    componentWillMount(){

    }

    componentDidMount(){

    }

    componentWillUnmount(){

    }

    

    /* Header */
    onHeaderLeftBtnClick = () => {
        const {pageIdentifier} = this.state;

        switch(pageIdentifier) {
            case ConstantsLg.LOGIN_PAGE_IDENTIFIER.PROFESSIONAL_RESET_PSWD_PAGE:
                this.setState({
                    title: ContentLg.REC_LOGIN_TITLE,
                    showBack : false,
                    showClose: true,
                    showFooter : true,
                    isNextDisabled: false,
                    btnNextLabel: ContentLg.BTN.SEND_EMAIL,
                    pageIdentifier: ConstantsLg.LOGIN_PAGE_IDENTIFIER.PROF_LOGIN_PAGE
                });
                break;
        }
    };

    onSuccessGoogleLogin = () => {
        this.onSuccessLoginGoogle();
    };

    onSuccessLoginGoogle = () => {
        this.props.onLoginSuccessProfessional();
    };

    _getBase64Image = (img_url, callBack) => {
        let img = new Image();
        img.setAttribute('crossOrigin', 'anonymous');
        img.src = img_url;

        // Create an empty canvas element
        let canvas = document.createElement("canvas");

        let checkExist = setInterval(function() {
            if(img.naturalHeight > 0 && img.naturalWidth > 0){
                clearInterval(checkExist);
                canvas.width = img.naturalWidth;
                canvas.height = img.naturalHeight;
                let ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0);
                callBack(canvas.toDataURL("image/png"));
            }
        }, 100);
    };

    responseGoogleSuccess = (response) => {
        this.props.showAppLodingView();
        this.responseGoogleSuccessAfterLoading(response);
    };
    
    responseGoogleSuccessAfterLoading = (response) => {
        // FIXME Rahul
        let user_info = {};
        user_info['google_name'] = response.w3.ig;
        user_info['google_email'] = response.w3.U3;
        user_info['google_user_access_token'] = response.accessToken;
        user_info['google_user_id'] = response.w3.Eea;
        user_info['google_user_profile_pic'] = response.w3.Paa;
        user_info['google_login_id_token'] = response.tokenId ? response.tokenId : (response.tokenObj && response.tokenObj.id_token) ? response.tokenObj.id_token : null;
        let CancelToken = axios.CancelToken;
        this._getBase64Image(user_info['google_user_profile_pic'], function(profile_data_url){

            const fdata = new FormData();
            fdata.append('login_type','3');
            fdata.append('app_id','1');
            fdata.append('google_name', user_info['google_name']);
            fdata.append('google_email',user_info['google_email']);
            fdata.append('google_user_access_token',user_info['google_user_access_token']);
            fdata.append('google_user_id',user_info['google_user_id']);
            fdata.append('gl_profile_pic',profile_data_url);
            fdata.append('action_type', ConstantsLg.ACTIONS.ACTION_LOGIN_USING_GOOGLE);
            fdata.append('google_login_id_token', response.tokenId ? response.tokenId : (response.tokenObj && response.tokenObj.id_token) ? response.tokenObj.id_token : null);
            
            axios({
                timeout: 120 * 1000,
                method: 'post',
                url: ConstantsLg.ROUTE.PROF_LOGIN_BY_EMAIL,
                withCredentials:true,
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    _cancelGoogleLogin  = c;
                }),
                data: fdata

            }).then( res => {
                if(res.data.data.login_info.is_new_user == 1){
                    window.triggerCkAnalytics("send", "event", "Login/Signup", "Professional - Login Success", "Google Login", "New User");
                }else{
                    window.triggerCkAnalytics("send", "event", "Login/Signup", "Professional - Login Success", "Google Login", "Returning User");
                }
                this.onSuccessGoogleLogin();
                
            }).catch( error =>{
                console.log(error);
                //FIXME should use intercepter
                this.setState({
                    loginInProgress : false
                });
            });
        }.bind(this));
    };

    responseGoogleFailure = (response) => {
        console.log(response);
        console.log("Failure")
    };

    onHeaderRightBtnClick = () => {
        const {pageIdentifier} = this.state;

        switch(pageIdentifier) {
            default:
                this.props.onClose();
        }
    };

    onBackClick = () => {
        const {pageIdentifier} = this.state;

        switch (pageIdentifier) {
            case ConstantsLg.LOGIN_PAGE_IDENTIFIER.PROF_LANDING_PAGE:
                this.props.showLoginModalLanding();
                break;
            case ConstantsLg.LOGIN_PAGE_IDENTIFIER.PROF_LOGIN_PAGE:
                this.setState({
                    title: ContentLg.SIGNUP_LOGIN,
                    showBack : false,
                    showClose: true,
                    showFooter : true,
                    pageIdentifier : ConstantsLg.LOGIN_PAGE_IDENTIFIER.PROF_LANDING_PAGE
                });
                break;
            case ConstantsLg.LOGIN_PAGE_IDENTIFIER.PROFESSIONAL_RESET_PSWD_PAGE:
                this.setState({
                    title: ContentLg.REC_LOGIN_TITLE,
                    showBack : false,
                    showClose: true,
                    showFooter : true,
                    isNextDisabled: false,
                    btnNextLabel: ContentLg.BTN.SEND_EMAIL,
                    pageIdentifier: ConstantsLg.LOGIN_PAGE_IDENTIFIER.PROF_LOGIN_PAGE
                });
                break;
        }
    };

    onNextClick = () => {
        const {pageIdentifier} = this.state;

        switch (pageIdentifier) {
            case ConstantsLg.LOGIN_PAGE_IDENTIFIER.PROF_LANDING_PAGE:
                this.onLandingNextBtnClick();
                break;
            case ConstantsLg.LOGIN_PAGE_IDENTIFIER.PROF_LOGIN_PAGE:
                this.onLoginSubmitClick();
                break;
            case ConstantsLg.LOGIN_PAGE_IDENTIFIER.PROFESSIONAL_RESET_PSWD_PAGE:
                this.onResetPswdSubmitClick();
                break;
        }
    };

    /* Landing */
    onLandingTxtBxEmailChange = (value, obj) => {
        this.professionalEmail = value;
        this.setState({
            showMessageEmailDirty: false
        });
        
        this.isEmailValid = obj.hasValue && obj.isValid;
    };

    onLandingNextBtnClick = () => {
        // window.triggerCkAnalytics("send", "event", "Login/Signup", "Recruiter - Email Entered");
        this.verifyRecruiterEmail();
    };

    onTxtBxEmailEnter = () => {
        // this.landingScrnRef.txtBxEmailFocusOut();
        this.verifyProfessionalEmail();
    };

    verifyProfessionalEmail = () => {
        if(this.isEmailValid) {
            Services.xhrVerifyProfessionalEmail({email: this.professionalEmail}, this.onVerifyProfessionalEmailSuccess, this.onVerifyProfessionalEmailFailure);
        }
        else {
            this.setState({
                showMessageEmailDirty: true
            });
        }
    };

    onVerifyProfessionalEmailSuccess = (emailInfo) => {
        if (emailInfo && emailInfo.flow) {

            if (emailInfo.flow === 1) {
                this.setState({
                    pageIdentifier: ConstantsLg.LOGIN_PAGE_IDENTIFIER.PROF_LOGIN_PAGE,
                    title: ContentLg.REC_LOGIN_TITLE,
                    btnNextLabel: ContentLg.BTN.LOGIN
                });
            } 
            else if(emailInfo.flow === 2) {
                this.setState({
                    title: "",
                    showBack : false,
                    showClose: true,
                    showFooter : false,
                    successHeader: ContentLg.REC_SUCCESS_HDR_SIGNUP,
                    successMsg: ContentLg.REC_SUCCESS_MSG_SIGNUP,
                    pageIdentifier : ConstantsLg.LOGIN_PAGE_IDENTIFIER.PROFESSIONAL_SUCCESS
                });
            }
            else if(emailInfo.flow === 3) {
                 // FIXME: Rahul
                // TODO: Rahul
            }
            else {
                // FIXME: Rahul
                // TODO: Rahul
            }

        } 
        else {
            // FIXME: Rahul
        }
    };

    onVerifyProfessionalEmailFailure = () => {
        // FIXME: Rahul
    };

    signUpProfessional = () => {
        // this.props.toShowOverlay(true);
        Services.signUpProfessional({
            email: this.professionalEmail,
            onSuccess: (data) => {
                // this.props.toShowOverlay(false);
                if (data.signup_info) {
                    // window.triggerCkAnalytics("send", "event", "Login/Signup", "Recruiter - Verification Link Sent");

                    this.setState({
                        title: "",
                        showBack : false,
                        showClose: true,
                        showFooter : false,
                        successHeader: ContentLg.REC_SUCCESS_HDR_SIGNUP,
                        successMsg: ContentLg.REC_SUCCESS_MSG_SIGNUP,
                        pageIdentifier : ConstantsLg.LOGIN_PAGE_IDENTIFIER.PROFESSIONAL_SUCCESS
                    });
                }
            },
            onFailure: () => {
                this.props.toShowOverlay(false);
               
            }
        });
    };

    
    onTxtBxPswdChange = (value, obj) => {
        
        this.professionalPassword = value;

        this.setState({
            pswdValidationMsg: null
        });
        this.isPswdValid = obj.hasValue && obj.isValid;
    };

    onBlurPassword = (value) => {
        if(!this.isPswdDirty) {

        }
        else if(!this.isPswdValid) {
            this.setState({
                pswdValidationMsg: ContentLg.MSG.INVALID_MIN_PSWD
            });
        }
        else {
            this.setState({
                pswdValidationMsg: null
            });
        }
    };

    onLoginSubmitClick = () => {
        this.loginProfessional();
    };

    onTxtBxPswdEnter = () => {
        // this.loginScrnRef.txtBxPswdFocusOut();
        this.loginProfessional();
    };

    loginProfessional = () => {
        if(this.isPswdValid) {
            Services.loginProfessional({
                email: this.professionalEmail,
                password: this.professionalPassword,
                onSuccess: (data) => {
                    this.props.toShowOverlay(false);
                    let verification_info = data.login_verification_info;
    
                    if(verification_info.is_verified_user && verification_info.is_password_matched){
                        // window.triggerCkAnalytics("send", "event", "Login/Signup", "Recruiter - Verified");
                        this.props.showAppLodingView();
                        this.props.onLoginSuccessProfessional();
                    }
                    else if(verification_info.is_verified_user && !verification_info.is_password_matched){
                        
                        this.setState({
                            pswdValidationMsg: ContentLg.MSG.WRONG_PSWD
                        });
                    }
                },
                onFailure: ()=>{
                    this.props.toShowOverlay(false);
                }
            });
        }
        else {
            let pswdValidationMsg = ContentLg.MSG.INVALID_PSWD;
            if(this.professionalPassword.length < 6) {
                pswdValidationMsg = ContentLg.MSG.INVALID_MIN_PSWD
            }
            
            this.setState({
                pswdValidationMsg
            });
        }
    };

    onEmailEditClick = () => {
        this.setState({
            title: ContentLg.SIGNUP_LOGIN,
            showBack : false,
            showClose: true,
            showFooter : true,
            pageIdentifier : ConstantsLg.LOGIN_PAGE_IDENTIFIER.PROF_LANDING_PAGE,
            pswdValidationMsg: null
        });
    };

    /* Reset password */
    onForgotPassword = () => {
        this.setState({
            title: ContentLg.RESET_PSWD,
            showBack : false,
            showClose: false,
            showFooter : true,
            isNextDisabled: false,
            btnNextLabel: ContentLg.BTN.SEND_EMAIL,
            pageIdentifier : ConstantsLg.LOGIN_PAGE_IDENTIFIER.PROFESSIONAL_RESET_PSWD_PAGE,
            pswdValidationMsg: null
        });
    };

    onResetPswdSubmitClick = () => {
        // this.props.toShowOverlay(true);
        Services.resetPasswordProfessional({
            email: this.professionalEmail,
            onSuccess: (data)=>{
                // this.props.toShowOverlay(false);
                if( data){ //success
                    this.setState({
                        title: "",
                        showBack: false,
                        showClose: true,
                        showFooter : false,
                        successHeader: ContentLg.REC_SUCCESS_HDR_RESET_PSWD,
                        successMsg: ContentLg.REC_SUCCESS_MSG_RESET_PSWD,
                        pageIdentifier : ConstantsLg.LOGIN_PAGE_IDENTIFIER.PROFESSIONAL_SUCCESS
                    });
                }else{

                }
            }
        });
    };

    onClickChangeUserLoginModal = () => {
        this.props.onClickChangeUserLoginModal(ConstantsLg.LOGIN_TYPE.PROFESSIONAL)
    };

    getViewToBeRendered = pageIdentifier => {
        switch (pageIdentifier){
            case ConstantsLg.LOGIN_PAGE_IDENTIFIER.PROF_LANDING_PAGE:
                const {emailValidationMsg} = this.state;
                return (
                    <LandingScreenProfessionalEmail
                        ref = {e=>this.landingScrnRef=e}
                        email = {this.professionalEmail}
                        emailValidationMsg = {emailValidationMsg}
                        onTxtBxEmailChange = {this.onLandingTxtBxEmailChange}
                        onTxtBxEmailEnter = {this.onTxtBxEmailEnter}
                        // onClickChangeUserLoginModal = {this.onClickChangeUserLoginModal}
                        showMessageEmailDirty = {this.state.showMessageEmailDirty}
                        // showMessagePublicEmailDomain = {this.state.showMessagePublicEmailDomain}
                    />
                );
            case ConstantsLg.LOGIN_PAGE_IDENTIFIER.PROF_LOGIN_PAGE:
                const {pswdValidationMsg} = this.state;
                return (
                    <LoginScreen
                        ref = {e=>{this.loginScrnRef=e}}
                        email = {this.professionalEmail}
                        pswdValidationMsg = {pswdValidationMsg}
                        onTxtBxPswdChange = {this.onTxtBxPswdChange}
                        onTxtBxPswdEnter = {this.onTxtBxPswdEnter}
                        onEmailEditClick = {this.onEmailEditClick}
                        onForgotPassword = {this.onForgotPassword}
                        onClickChangeUserLoginModal = {this.onClickChangeUserLoginModal}
                        onClickLoginProfessional = {this.loginProfessional}
                        // onBlurPassword = {this.onBlurPassword}
                        // showErrorMessagePasswordMismatch = {this.state.showErrorMessagePasswordMismatch}
                    />
                );
            case ConstantsLg.LOGIN_PAGE_IDENTIFIER.PROFESSIONAL_SUCCESS:
                const {successHeader, successMsg} = this.state;
                return (
                    <SuccessScreen
                        header = {successHeader}
                        message = {successMsg}
                        email = {this.professionalEmail}
                        onEmailEditClick = {this.onEmailEditClick}
                        onClickChangeUserLoginModal = {this.onClickChangeUserLoginModal}
                    />
                );
            case ConstantsLg.LOGIN_PAGE_IDENTIFIER.PROFESSIONAL_RESET_PSWD_PAGE:
                return (
                    <ResetPasswordScreen
                        email = {this.professionalEmail}
                        onClickChangeUserLoginModal = {this.props.onClickChangeUserLoginModal}
                        onClickSendLink = {this.onNextClick}
                        onEmailEditClick = {this.onEmailEditClick}
                    />
                );
            default:
                return;
        }
    };

    onClickCrossIcon = () => {
        this.props.onClickCrossIconForRecruiter();
    };

    render () {
        const {
            title,
            showBack,
            showClose,
            showFooter,
            isNextDisabled,
            pageIdentifier,
            btnBackLabel,
            btnNextLabel
        } = this.state;

        const classes = makeStyles(theme => ({
            container: {
              display: 'flex',
              flexWrap: 'wrap',
            },
            textField: {
              marginLeft: theme.spacing(1),
              marginRight: theme.spacing(1),
              backgroundColor: 'red',
              color: 'red'
            },
            dense: {
              marginTop: theme.spacing(2),
            }
          }));

        return (
            <div className="mobile-login-modal-wrapper">
                <MobileModal 
                    isOpen = {true} 
                    onClose = {this.props.onClose} 
                    style = {{
                        top:'30%',
                        height:'70%'
                    }} 
                    {...this.props}
                    noBackdrop = {false}
                >
                    <LoginHeader2 
                        title = {ContentLg.SIGNUP_LOGIN}
                        customStyleLoginPopupHeader = {{
                            padding: '0',
                            width: '100%',
                            justifyContent: 'center'
                        }}
                    />

                    {
                        pageIdentifier != ConstantsLg.LOGIN_PAGE_IDENTIFIER.PROFESSIONAL_SUCCESS ?
                        <div className="lp_parent_header_container">
                            <div className="lp_header_container">
                                <span className="lp_content_title padding4">{ContentLg.CANDIDATE_LANDING_SUB_HDR}</span>
                            </div>
                        </div>
                        :
                        null
                    }
                    

                        {this.getViewToBeRendered(pageIdentifier)}  
                        {/* {this.getViewToBeRendered(ConstantsLg.LOGIN_PAGE_IDENTIFIER.PROFESSIONAL_SUCCESS)} */}
                        {
                            pageIdentifier != ConstantsLg.LOGIN_PAGE_IDENTIFIER.PROFESSIONAL_SUCCESS ?
                            <span>
                                <div className="word-with-line-wrapper">
                                    <div className="word-with-line">
                                        <span className="only-word">or</span>
                                    </div>
                                </div>
                                <div className="google-login-individual">
                                    <GoogleLogin
                                        clientId = {ConstantsLg.GOOGLE_CLENT_ID}
                                        render = {renderProps => (
                                            <div
                                                className="gl-login"
                                                id = 'google-login-btn'
                                                ref = {googleBtn => {this.googleBtn = googleBtn;}}
                                                onClick = {renderProps.onClick}
                                            >
                                                <div className="google-icon">
                                                    <img src={ConstantsLg.ICONS.GOOGLE_ICON_RED}/>
                                                </div>
                                                <div className="google-content">Continue with Google</div>
                                            </div>
                                        )}
                                        onSuccess = {this.responseGoogleSuccess}
                                        onFailure = {this.responseGoogleFailure}
                                    />
                                </div>
                            </span>
                            :
                            null
                        }
                        
                </MobileModal>
            </div>
        );
    }
}

ProfessionalLoginEmailMobile.PropTypes = {
    onLoginSuccess: PropTypes.func.isRequired
};

export default ProfessionalLoginEmailMobile;




// WEBPACK FOOTER //
// ./src/components/ProfessionalLoginEmailMobile/ProfessionalLoginEmailMobile.js